import { Component, computed, signal } from "@angular/core";

import { LiquidElementVideo, LiquidVideo } from "../../../liquid-page.models";

@Component({
    selector: 'meta-liquid-video',
    templateUrl: './liquid-video.component.html',
    styleUrls: ['./liquid-video.component.css'],
})
export class LiquidVideoComponent {
    $input = signal<LiquidElementVideo | undefined>(undefined);
    $output = computed<LiquidVideo>(() => {
        if (this.$input()) {
            return {
                src: this.$input()?.value,
                captions: this.$input()?.captions,
            };
        }

        return { src: undefined };
    })
}